const MAX_ACTIVE = 4, MAX_QUEUED = 32;
let active = 0;
const queue = [];
function drain() {
    while (active < MAX_ACTIVE && queue.length) {
        const item = queue.shift();
        item.signal?.removeEventListener("abort", item.abort);
        if (item.signal?.aborted) { item.reject(item.signal.reason); continue; }
        active++;
        Promise.resolve().then(item.task).then(item.resolve, item.reject).finally(() => { active--; drain(); });
    }
}
// A shared budget keeps independent overview regions from multiplying reads.
export function runDiscoveryRead(task, { signal } = {}) {
    if (signal?.aborted) return Promise.reject(signal.reason);
    if (queue.length >= MAX_QUEUED) return Promise.reject(new Error("Too many pending reads. Refresh when the current reads finish."));
    return new Promise((resolve, reject) => {
        const item = { task, signal, resolve, reject, abort: () => {
            const index = queue.indexOf(item);
            if (index >= 0) queue.splice(index, 1);
            reject(signal.reason);
        } };
        signal?.addEventListener("abort", item.abort, { once: true });
        queue.push(item); drain();
    });
}
